<template>
  <div class="app">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12" style="padding-left: 0px; padding-right: 0px;">
                <left-nav></left-nav>
                 <div id="appContainer">
                   <header class="titleRow">
                    <div class="row">
                      <div class="col-sm-4">
                          <h4>Customers / <router-link :to="{name: 'RelationshipsEdit', params: { id: $route.params.id }}">{{ company.name }}</router-link></h4>
                      </div>
                      <div class="col-sm-3">
                      </div>
                      <div class="col-sm-4">
                        <div align="right">
                          <router-link :to="{name: 'RelationshipsEditCompany', params: { id: $route.params.id }}" class="btnGreenLineHeader" style="margin-top: -3px;">Edit Customer</router-link>
                        </div>
                      </div>
                      <div class="col-sm-1">
                         
                      </div>
                    </div>
                  </header>
                  <app-content></app-content>
                  <prices></prices>
                 </div>
             </div>
        </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import LeftNav from '@/components/nav/Relationships.vue'
import AppContent from '@/views/relationships/Overview.vue'
import Prices from '@/views/relationships/RiskAssements.vue'

import axios from 'axios'

export default {
  // name: 'Home',
  components: {
    LeftNav,
    AppContent,
    Prices
  },
  data () {
    return {
      company: {}
    }
  },
  created () {
    axios
      .get(`/api/companies/${this.$route.params.id}`)
      .then((res) => {
        this.company = res.data
      })
  }
}
</script>
